export const WALLET_KEY_BACKUP_ROUTE = '/v1/wallet_key_backup?wallet_key_id=';
